<nav
  class="navbar navbar-expand-md d-flex justify-content-between"
  style="box-shadow: none"
>
  <div class="px-3">
    <a class="navbar-brand" href="/pages/home"
      ><svg-icon
        class="header-logo"
        [src]="'../../../assets/images/aar_logo.svg'"
      ></svg-icon
    ></a>
  </div>
  <div class="px-3">
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <div class="mt-1 me-4 header d-flex flex-row justify-content-end">
        <app-nav-item-list
          [items]="navItems"
          *ngIf="!isSignedIn"
        ></app-nav-item-list>
        <app-profile-menu-switch
          (emitSignOut)="signOut()"
          *ngIf="isSignedIn"
        ></app-profile-menu-switch>
        <app-language-switch></app-language-switch>
      </div>
    </div>
  </div>

  <button
    class="navbar-toggler"
    type="button"
    data-toggle="collapse"
    data-target="#navbarSupportedContent"
    aria-controls="navbarSupportedContent"
    aria-expanded="false"
    aria-label="Toggle navigation"
    (click)="!isSignedIn ? modal.openModal() : loggedInModal.openModal()"
  >
    <svg-icon
      class="icon-navbar-toggler"
      [src]="'../../../assets/images/icons/navbar-toggler-icon.svg'"
    ></svg-icon>
  </button>
</nav>
<nav class="navbar navbar-expand-md d-md-flex d-none justify-content-center">
  <app-nav-item-list
    [items]="loggedInNavItems"
    *ngIf="isSignedIn"
  ></app-nav-item-list>
</nav>
<app-menu-modal [hidden]="isSignedIn" #modal [items]="navItems">
</app-menu-modal>
<app-menu-modal
  [hidden]="!isSignedIn"
  #loggedInModal
  [items]="loggedInNavItems"
  [showProfile]="true"
  (signOutEmitter)="signOut()"
>
</app-menu-modal>
<!-- <div class="mt-1 me-4 header d-flex flex-row justify-content-end">
<app-nav-item-list [items]="navItems" *ngIf="!isSignedIn"></app-nav-item-list>
<app-nav-item-list [items]="loggedInNavItems" *ngIf="isSignedIn"></app-nav-item-list>
  <app-language-switch></app-language-switch>
  <app-profile-menu-switch></app-profile-menu-switch>
</div> -->
